import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { apiGet } from '../../api/client';
import { relativeTime } from '../../util/time';

interface Entry {
  id: string;
  action: string;
  targetType: string;
  targetId: string | null;
  details: Record<string, unknown>;
  createdAt: string;
  actorBattletag: string | null;
}

export function Audit() {
  const [page, setPage] = useState(1);
  const q = useQuery({
    queryKey: ['admin', 'audit', page],
    queryFn: () => apiGet<{ items: Entry[] }>(`/api/admin/audit?page=${page}`),
  });
  return (
    <div data-testid="admin-audit">
      {q.isPending && <p className="muted">Loading...</p>}
      {q.data && (
        <>
          <div className="table-scroll">
            <table className="grid">
              <thead>
                <tr>
                  <th>When</th>
                  <th>Who</th>
                  <th>Action</th>
                  <th>Target</th>
                  <th>Details</th>
                </tr>
              </thead>
              <tbody>
                {q.data.items.map((e) => (
                  <tr key={e.id} data-testid="audit-row">
                    <td>{relativeTime(e.createdAt)}</td>
                    <td>{e.actorBattletag ?? 'system'}</td>
                    <td>
                      <code>{e.action}</code>
                    </td>
                    <td>
                      {e.targetType} <span className="muted">{e.targetId?.slice(0, 8)}</span>
                    </td>
                    <td>
                      <code>{JSON.stringify(e.details)}</code>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="pager">
            <button type="button" disabled={page <= 1} onClick={() => setPage(page - 1)}>
              Previous
            </button>
            <span>Page {page}</span>
            <button
              type="button"
              disabled={q.data.items.length < 50}
              onClick={() => setPage(page + 1)}
            >
              Next
            </button>
          </div>
        </>
      )}
    </div>
  );
}
